<template>
  <el-dialog title="通用类型"
             :visible.sync="modelValue"
             :close-on-click-modal="false"
             top="100px"
             destroy-on-close
             @open="handleOpen"
             append-to-body
             width="40%"
             :before-close="handleClose"
             custom-class="custom-dialog-class">

    <template #default>
      <div class="general-type-container">
        <div class="buttons">
          <el-button type="primary" size="small" @click="addHandler" >新建类型</el-button>
        </div>
        <div class="table-container">
          <el-scrollbar>
            <el-table
                :data="table"
                style="width: 100%"
                :header-cell-style="{ background : '#EFEFEF' }">
              <el-table-column
                  prop="serialNumber"
                  align="center"
                  label="序号"/>
              <el-table-column
                  prop="typeName"
                  align="center"
                  label="类型名称"/>
              <el-table-column
                  prop=""
                  align="center"
                  label="操作">
                <template #default="{ row }">
                  <div class="links">
                    <el-link type="primary" @click="editHandler(row)" >编辑</el-link>
                    <el-popconfirm
                        title="确定要删除该通用类型吗？"
                        @confirm="deleteHandler(row)">
                      <template #reference>
                        <el-link class="danger-link-class" type="danger">删除</el-link>
                      </template>
                    </el-popconfirm>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-scrollbar>
        </div>
        <div class="footer-container">
          <el-button type="primary" @click="handleClose(closeHandler)" >确 认</el-button>
          <el-button @click="handleClose(closeHandler)">取 消</el-button>
        </div>

        <AddGeneralType v-model="addData.isShow" :id="addData.id" @updateList="getList" />
      </div>
    </template>
  </el-dialog>
</template>

<script>
import AddGeneralType from "../AddGeneralType";
export default {
  name: "ListGeneralType",
  components: {
    AddGeneralType
  },
  props: {
    value: {
      type: Boolean,
      default: () => false,
    }
  },
  data() {
    return {
      table: [],
      addData: {
        id: "",
        isShow: false,
      }
    };
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  mounted() {

  },
  methods: {
    addHandler() {
      this.addData.id = "";
      this.addData.isShow = true;
    },
    editHandler(e) {
      this.addData.id = e.id;
      this.addData.isShow = true;
    },
    async deleteHandler(e) {
      try {
        const res = await this.$get(`imageCategory/delete/${e.id}`);
        if (!res) return false;
        await this.getList();
      }catch (e) {
        console.error(`删除通用类型失败: ${e}`);
      }
    },
    async getList() {
      try {
        const res = await this.$get("imageCategory/list");
        if (!res) return false;
        const { data } = res;
        this.table = data;
      }catch (e) {
        console.error(`获取通用类型列表失败: ${e}`);
      }
    },
    handleOpen() {
      this.getList();
    },
    closeHandler() {
      this.modelValue = false;
    },
    handleClose(done) {
      this.table = [];
      done();
    },
  },
}
</script>

<style scoped lang="scss">
.general-type-container{

}
.buttons{
  margin-bottom: 28px;
}
.table-container{
  height: calc(100vh - 500px);
  padding-bottom: 28px;
  .el-scrollbar{
    height: 100%;
    :deep(.el-scrollbar__wrap) {
      overflow-x: hidden;
    }
  }
}
.footer-container{
  padding-top: 28px;
  border-top: 1px solid #EBECF0;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-button{
    width: 120px;
  }
  .el-button + .el-button{
    margin-left: 50px;
  }
}
.danger-link-class {
  margin-left: 10px;
}
</style>
